import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

    email: string;
    sent: boolean = false;
    errMsg: string;

    constructor(private authService: AuthService) { }

    ngOnInit() {
    }

    forgotPassword() {
        this.authService.forgotPassword(this.email).subscribe(
            (res) => {
                if (res.success) {
                    this.sent = true;
                } else {
                    this.errMsg = res.err;
                }
            },
            (error) => this.errMsg = error
        );
    }
}
